import { useParams } from "react-router-dom";
import { Qmodule } from "../../shared/Services/Graphql/querys/q_module";

export const ContentModule = () => {
  const { module } = useParams();
  const { content } = Qmodule({ id: module as string });

  return content && JSON.parse(content);
};
